import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { PaymentState } from './types';

const selectCache = (state: RootState) => state.paymentCache;

export const selectCheckoutSessionSecret = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.checkoutSessionSecret
);

export const selectCheckingOut = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.checkingOut
);

export const selectPaymentError = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.error
);

export const selectGettingPaymentTypePrice = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.gettingPaymentTypePrice
);

export const selectPaymentTypePrice = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.paymentTypePrice
);

export const selectIsCheckingCheckoutSessionStatus = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.checkingCheckoutSessionStatus
);

export const selectCheckoutSessionStatus = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.checkoutSessionStatus
);

export const selectPostPaymentId = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.postPaymentId
);

export const selectConfirmingPostPayment = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.confirmingPostPayment
);

export const selectPostPaymentConfirmed = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.postPaymentConfirmed
);

export const selectPriceIncludeTax = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.priceIncludeTax
);

export const selectPaymentIntentId = createSelector(
  selectCache,
  (cache: PaymentState) => cache?.paymentIntentId
);
